<template>
	<div :class="[companyClass , canScroll]">
		<div class="page-table column mb-20" :class="{'flex':!isMobile, 'overflow':isMobile}">
			<div class="page-header">
				<h1 class="pageTitle">financing</h1>
				<h4>partners &amp; agents</h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>partners &amp; agents</el-breadcrumb-item>
					<el-breadcrumb-item>financing</el-breadcrumb-item>
					<el-breadcrumb-item>view financing</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div>
				<h2 class="pageTitle" style="float: right;">running balance: {{pageTitle}} {{runningBalance}}</h2>
			</div>

			<div class="mt-0" >
				<div style="float: right;">
					<el-select v-model="entry.ledgerAccountID" filterable clearable placeholder="Select Account" class="ml-5" 
					@change="setTitle" style="width:60%">
						<el-option
						v-for="ledger in ledgerAccounts"
						:key="ledger.id"
						:label="ledger.name"
						:value="ledger.id">
						</el-option>
					</el-select>
					<el-button v-show="showDelete && userPermissionsFilter.deletecompanies" type="danger" icon="el-icon-delete" 
						@click="deleteSelectedPrompt"></el-button>
					<el-button v-show="!showDelete && userPermissionsFilter.addcompanies"  type="warning" icon="el-icon-search"
					@click="refreshEntries"></el-button>
					<el-button v-show="!showDelete && userPermissionsFilter.addcompanies"  type="primary" icon="el-icon-plus"
						@click="entryDialogFormVisible = true"></el-button>
				</div>
				<div style="float: right;">
					<el-row :gutter="5">
						<el-col :span="12">
							<el-date-picker style="width: 100%"
							v-model="entry.fromDate"
							@change="fromDateChanged"
							type="date"
							format="yyyy-MM-dd"
							placeholder="From Date">
							</el-date-picker>
						</el-col>
						<el-col :span="12">
							<el-date-picker style="width: 100%"
							v-model="entry.toDate"
							type="date"
							format="yyyy-MM-dd"
							placeholder="To Date">
							</el-date-picker>
						</el-col>
					</el-row>
				</div>
			</div>

			<div class="toolbar-box flex">
				<div class="search-box box grow">
					<div><i class="mdi mdi-magnify"></i></div>
					<input v-model="search" placeholder="Search..."/>
				</div>
				<div class="pagination-box animated fadeInRight">
					<div class="select-box">
						<el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini">
							<el-option value="10" label="10"></el-option>
							<el-option value="15" label="15"></el-option>
							<el-option value="20" label="20"></el-option>
							<el-option value="30" label="30"></el-option>
							<el-option value="50" label="50"></el-option>
							<el-option value="100" label="100"></el-option>
						</el-select>
					</div>
					<div class="label"> /page</div>
				</div>
				<div class="csv-box animated fadeInRight">
					<button @click="downloadData">download csv ({{total}})</button>
				</div>
			</div>

			<resize-observer @notify="handleResize" />
			
			<div class="table-box card-base card-shadow--medium box grow" id="table-wrapper" v-loading="!asyncComponent">
				<div :style="{ 'width': width + 'px' }">
					<!-- v2-table -->
					<component :is="asyncComponent" ref="table"
						:data="list"
						:height="height"
						:border="false"
						:total="total"
						:lazy-load="false"
						:loading="loading"
						class="styled"
						:class="{'mobile':isMobile}"
						@page-change="handlePageChange"
						:pagination-info="paginationInfo"
						:default-sort="{prop:sortingProp, order:sortingOrder}"
						@sort-change="handleSortChange"
						@select-change="handleSelectChange"
						:show-summary="showSummary"
						:shown-pagination="shownPagination">
						<v2-table-column type="selection" width="45"></v2-table-column>
						<v2-table-column label="Ledger Account" prop="ledgerAccountName" sortable width="260" :fixed="isMobile?'':'left'"></v2-table-column>
						<v2-table-column label="Debited" prop="debitStr" sortable align="left" 
						:fixed="isMobile?'':'left'"></v2-table-column>
						<v2-table-column label="Credited" prop="creditStr" align="left" width="100"
						:fixed="isMobile?'':'left'"  sortable></v2-table-column>
						<v2-table-column label="Balance" prop="balanceStr" sortable align="right"
						:fixed="isMobile?'':'right'"  width="150"></v2-table-column>
						<v2-table-column label="Entry Type" prop="entryTypeStr" sortable align="center" width="100"></v2-table-column>
						<v2-table-column label="Created On" prop="createdOnStr" sortable width="100"></v2-table-column>
					</component><!-- v2-table -->
				</div>
			</div>

		<el-dialog title="Add ledger entry" :visible.sync="entryDialogFormVisible"
		v-loading="pageLoading" 
		:element-loading-text="loadingText"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-row :gutter="20">
			<el-col :span="12">
				<span>Ledger Account to credit</span><span :class="required"> *</span>
				<el-select v-model="entry.ledgerAccountID" filterable clearable placeholder="Select Account" class="mb-10" 
					style="width:100%" name="account" v-validate="'required'" 
					@change="accountChanged">
						<el-option
						v-for="ledger in ledgerAccounts"
						:key="ledger.id"
						:label="ledger.name"
						:value="ledger.id">
						</el-option>
					</el-select>
					<transition name="fade">
						<span class="danger-text">{{ errors.first('account') }}</span>
					</transition>
			</el-col>
			<el-col :span="12">
				<span>Base Currency</span><span :class="required"> *</span>
				<el-input placeholder="Base Currency" readonly="true" v-model="baseCurrency"></el-input>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="mt-10">
			<el-col :span="12">
				<span>Credit Amount in {{creditAmount}}</span><span :class="required"> *</span>
				<el-input placeholder="Base Currency" v-model="entry.credit"
				name="credit" v-validate="'required|decimal:2'" ></el-input>
				<transition name="fade">
					<span class="danger-text">{{ errors.first('credit') }}</span>
				</transition>
			</el-col>
		</el-row>
		<span slot="footer" class="dialog-footer">
			<el-button @click="entryDialogFormVisible = false">Cancel</el-button>
			<el-button type="primary" @click="validateAndSave">Credit Account</el-button>
		</span>
		</el-dialog>

		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'Financing',
	data() {
		return {
			baseCurrency: '',
			entryDialogFormVisible: false,
			runningBalance: 0,
			entry: {
				id: 0,
				ledgerAccountID: '',
				credit: '',
				fromDate: '',
				toDate: ''
			}
		}
	},
	computed: {
		creditAmount() {
			return this.baseCurrency ? `(${this.baseCurrency})` : '';
		}
	},
	methods: {
		downloadData() {
			this.getLedgerEntries(this.getSearchModel())
			.then(result=> {
				if(result.items)
					this.downloadCSV(result.items.map(p=> {
						var e = {
							Ledger_Name: p.ledgerAccountName,
							Debit_Amount: p.debitStr,
							Credit_Amount: p.creditStr,
							Entry_Type: p.entryTypeStr,
							Balance: p.balanceStr,
							Entry_Date: p.createdOnStr
						};

						return e;
					}));
			})
			.catch(err=> this.errorMessage('Error downloading data.'));
		},
		addFinancing() {
            router.push('/addfinancing/');
		},
		print(row) {
			router.push(`/updatefinancing/${row.id}`);
		},
        deleteSelectedFinancing() {
            if(this.selectedItems.length > 0){
				this.removeCompanyFinancing(this.selectedItems.map(p=> p.id))
				.then(response=> {
					if(response)
					{
						this.refreshFinancing();
						this.successMessage('selected financing(s) have been deleted.');
					}
				});
            }
		},
		accountChanged() {	
			this.baseCurrency = '';		
			this.getLedgerAccountCurrency(this.entry.ledgerAccountID)
			.then(result=> {
				if(result){
					this.baseCurrency = result.nameCode;
					this.pageTitle = this.baseCurrency;
				}
				else{
					this.infoMessage('no base currency has been set for the beneficiary.');
				}
			})
			.catch(err=> console.log(err));
		},
		setTitle() {
			this.accountChanged();
			this.refreshEntries();
		},
		refreshEntries() {
			this.runningBalance = 0;
			if(this.entry.ledgerAccountID && this.entry.ledgerAccountID > 0){
				this.getLedgerEntries(this.getSearchModel())
				.then(result=> {
					if(result && result.items.length > 0){
						this.runningBalance = result.items[result.items.length -1].balanceStr;
					}
					this.tableRefreshed(result);
				})
				.catch(err=> this.tableRefreshed(this.defaultListResult));
			}
		},
		getSearchModel() {
			return {
					page: this.currentPage,
					size: this.paginationInfo.pageSize,
					ledgerId: this.entry.ledgerAccountID,
					fromDate: this.entry.fromDate,
					toDate: this.entry.toDate
				}
		},
		clearState() {
			this.entry = {
				id: 0,
				ledgerAccountID: '',
				credit: '',
				fromDate: '',
				toDate: ''
			};
			this.$validator.reset();
		},
		fromDateChanged(e) {
			if(this.entry.fromDate > this.entry.toDate)
				this.entry.toDate = this.entry.fromDate;
		},
		validateAndSave() {
			let self = this;
            this.$validator.validateAll()
            .then(result=> {
                if(result){
					this.startLoader('adding ledger entry...');
					
					self.addLedgerEntry(self.entry)
					.then(result=> {
						this.stopLoader();
						if(result){
							self.successMessage('Ledger entry added successfully.');
							self.entitySaved();
							self.refreshEntries();
						}
						else{
							self.errorMessage('Ledger entry not added.');
						}
						this.clearState();
						this.entryDialogFormVisible = false;
					})
					.catch(err=> {
						this.clearState();
						this.stopLoader();
						this.errorMessage('An error occured.');
						this.entryDialogFormVisible = false;
					});
                }
            })
            .catch(err=> console.log(err));
        }
	},
	created() {
		this.deleteEvent = 'deleteSelectedFinancing';
		this.refreshListEvent = 'refreshEntries';
		this.$on(this.refreshListEvent, this.refreshEntries);
		this.$on(this.deleteEvent, this.deleteSelectedFinancing);

		this.refreshEntries();
		this.getAllGeneralLedgerAccounts();	
    },
	mixins: [PermissionsMixins]
}
</script>